import MonthlyTourProgramDesktop from "../components/desktop/monthly-tour-program/MonthlyTourProgramDesktop"
import { useMediaQuery, useTheme } from "@mui/material";
import MonthlyTourProgramMobile from "../components/mobile/monthly-tour-program/MonthlyTourProgramMobile";

const MonthlyTourProgram = () => {
     const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return  (
        <>
           <>{isMobile ? <MonthlyTourProgramMobile /> : <MonthlyTourProgramDesktop />}</>
        </>
    )
}

export default MonthlyTourProgram